<template>
  <div class="flex-1 mx-auto flex flex-col">
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
      <div class="mt-8">
        <!-- Activity table (small breakopoint and up) -->
        <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div>
            <div class="sm:hidden">
              <label for="tabs" class="sr-only">Select a tab</label>
              <select
                id="tabs"
                name="tabs"
                class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
              >
                <option>My Account</option>
                <option>Company</option>
                <option>Billing</option>
              </select>
            </div>
            <div class="hidden sm:block">
              <nav class="flex space-x-4" aria-label="Tabs">
                <a
                  href="#"
                  class="bg-blue-100 text-blue-700 px-3 py-2 font-medium text-sm rounded-md"
                >
                  Available Purchases
                </a>
                <a
                  href="#"
                  class="text-gray-500 hover:text-gray-700 px-3 py-2 font-medium text-sm rounded-md"
                >
                  Expired Purchases
                </a>
                <a
                  href="#"
                  class="text-gray-500 hover:text-gray-700 px-3 py-2 font-medium text-sm rounded-md"
                >
                  All Purchases
                </a>
              </nav>
            </div>
          </div>
          <ul
            class="mt-4 space-y-2 divide-gray-200"
          >
            <li v-for="purchase in purchases" v-bind:key="purchase.id">
              <div class="block bg-white rounded-md overflow-hidden">
                <div class="px-4 py-4 sm:px-6">
                  <div class="flex items-center justify-between">
                    <p class="text-sm font-medium text-gray-800 truncate">
                      {{ purchase.video.title }}
                    </p>
                    <div class="ml-2 flex-shrink-0 flex">
                      <p
                        class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                      >
                        Available
                      </p>
                    </div>
                  </div>
                  <div class="mt-2 sm:flex sm:justify-between">
                    <div class="sm:flex">
                      <div
                        class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 space-x-1"
                      >
                        <!-- Heroicon name: solid/users -->
                        <span class="flex-shrink-0 h-5 w-5 flex items-center">
                          <i class="fas fa-user"></i>
                        </span>
                        <p>
                          {{ purchase.purchaser.name }}
                        </p>
                      </div>
                      <div
                        class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6 space-x-1"
                      >
                        <!-- Heroicon name: solid/users -->
                        <span class="flex-shrink-0 h-5 w-5 flex items-center">
                          <i class="fas fa-coins"></i>
                        </span>
                        <p>${{ purchase.price }}</p>
                      </div>

                      <div
                        class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6 space-x-1"
                      >
                        <!-- Heroicon name: solid/users -->
                        <span class="flex-shrink-0 h-5 w-5 flex items-center">
                          <i class="fad fa-sticky-note"></i>
                        </span>
                        <p>{{ purchase.owner.name }} / LSM</p>
                      </div>
                    </div>

                    <div
                      class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 space-x-1"
                    >
                      <!-- Heroicon name: solid/calendar -->
                      <span class="flex-shrink-0 h-5 w-5 flex items-center">
                        <i class="fad fa-calendar-check"></i>
                      </span>
                      <p>
                        Purchased on
                        <span>{{
                          purchase.created_at | displayLocalDateTime("M/D/YYYY")
                        }}</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="px-4 pb-4 sm:px-6 sm:pb-6">
                  <dt class="text-sm font-medium text-gray-500">
                    Attachments
                  </dt>
                  <dd class="mt-1 text-sm text-gray-900">
                    <ul
                      class="border border-gray-200 rounded-md divide-y divide-gray-200"
                    >
                      <li
                        class="pl-3 pr-4 py-3 flex items-center justify-between text-sm"
                      >
                        <div class="flex-1 flex items-center">
                          <!-- Heroicon name: solid/paper-clip -->
                          <div
                            class="flex flex-row items-center h-5 w-5 text-gray-400 text-lg"
                          >
                            <i class="far fa-file-video"></i>
                          </div>
                          <span class="ml-2 flex-1 w-0 truncate">
                            {{ purchase.video.upload_filename }}
                            <span class="text-gray-500 text-sm">
                              (expires at
                              {{
                                purchase.expires_at | displayLocalDateTime
                              }})</span
                            >
                          </span>
                        </div>
                        <div class="ml-4 flex-shrink-0">
                          <button
                            class="font-medium text-blue-600 hover:text-indigo-500 focus:outline-none"
                            v-on:click="download(purchase.video_id)"
                          >
                            Download
                          </button>
                        </div>
                      </li>
                    </ul>
                  </dd>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import * as Config from "@/config";

export default {
  name: "HelloWorld",
  data() {
    return {
      purchases: [],
      polling: true
    };
  },
  mounted() {
    this.getPurchasedVideos();
  },
  methods: {
    async getPurchasedVideos() {
      try {
        let res = await this.$http.get(Config.apiPath + "/api/v2/media/purchases")
        this.purchases = res.data
      } catch (e) {}
      this.polling = false
    },
    async download(id) {
      try {
        let res = this.$http
          .get(Config.apiPath + "/api/v2/media/purchases/download/" + id)

        var link = document.createElement("a");
        document.body.appendChild(link);
        link.href = res.data;
        link.click();
        document.body.removeChild(link);

      } catch (e) {
        this.$swal(
          "Uh oh!",
          "There has been an issue. It looks like you don't own this video. If this is a mistake, please open a support ticket or contact Brett Adair.",
          "error"
        );
      }
    }
  }
};
</script>

<style scoped></style>
